export default "query BirthdateValidationRules($locale:Locale!){validationRules:validationRules_v2(locale:$locale){birthdate{...ValidationRuleAttributes}}}"